import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getPartenaire, getStatistiques, getForages, getSecteurs } from '../services/api';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const PartenaireDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [partenaire, setPartenaire] = useState<any>(null);
  const [stats, setStats] = useState<any>(null);
  const [forages, setForages] = useState<any[]>([]);
  const [secteurs, setSecteurs] = useState<any[]>([]);

  useEffect(() => {
    if (!id) return;
    getPartenaire(id).then(r => setPartenaire(r.data));
    getStatistiques({ partenaire_id: id, annee: new Date().getFullYear().toString() }).then(r => setStats(r.data));
    getForages({ partenaire_id: id }).then(r => setForages(r.data));
    getSecteurs({ partenaire_id: id }).then(r => setSecteurs(r.data));
  }, [id]);

  if (!partenaire) return <div>Chargement...</div>;

  return (
    <div>
      <h2 style={{ marginBottom: 5, color: '#1565C0' }}>{partenaire.libelle}</h2>
      <p style={{ color: '#999', marginBottom: 20 }}>
        Code: {partenaire.code} | Responsable: {partenaire.responsable} | {partenaire.adresse} | {partenaire.telephone}
      </p>

      {/* Stats cards */}
      <div className="stat-boxes">
        <div className="stat-box bg-blue">
          <h4>Abonnes</h4>
          <div className="stat-box-value">{stats?.abonnes?.toLocaleString('fr-FR') || 0}</div>
        </div>
        <div className="stat-box bg-orange">
          <h4>Factures</h4>
          <div className="stat-box-value">{stats?.nbFactures?.toLocaleString('fr-FR') || 0}</div>
        </div>
        <div className="stat-box bg-green">
          <h4>Volume (m3)</h4>
          <div className="stat-box-value">{stats?.volumeTotal?.toLocaleString('fr-FR') || 0}</div>
        </div>
        <div className="stat-box bg-teal">
          <h4>Montant TTC</h4>
          <div className="stat-box-value">{stats?.montantTTC?.toLocaleString('fr-FR') || 0}</div>
        </div>
        <div className="stat-box bg-purple">
          <h4>Total paye</h4>
          <div className="stat-box-value">{stats?.totalPaye?.toLocaleString('fr-FR') || 0}</div>
        </div>
        <div className="stat-box bg-red">
          <h4>A recouvrer</h4>
          <div className="stat-box-value">{stats?.montantARecouvrer?.toLocaleString('fr-FR') || 0}</div>
        </div>
      </div>

      {/* Repartition categories */}
      {stats?.repartitionCategories && (
        <div className="chart-card" style={{ marginBottom: 20 }}>
          <h3>Repartition par categorie</h3>
          <div className="data-table-wrapper" style={{ boxShadow: 'none', padding: 0 }}>
            <table className="data-table">
              <thead>
                <tr>
                  <th>Categorie</th>
                  <th>Abonnes</th>
                  <th>Factures</th>
                  <th>Volume (m3)</th>
                  <th>Montant (FCFA)</th>
                </tr>
              </thead>
              <tbody>
                {stats.repartitionCategories.map((cat: any, i: number) => (
                  <tr key={i}>
                    <td><strong>{cat.categorie}</strong></td>
                    <td>{cat.nbAbonnes}</td>
                    <td>{cat.nbFactures}</td>
                    <td>{cat.volume?.toLocaleString('fr-FR')}</td>
                    <td>{cat.montant?.toLocaleString('fr-FR')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="charts-row">
        {/* Forages */}
        <div className="data-table-wrapper">
          <h3 style={{ marginBottom: 15 }}>Forages ({forages.length})</h3>
          <table className="data-table">
            <thead>
              <tr><th>Reference</th><th>Libelle</th><th>Localite</th></tr>
            </thead>
            <tbody>
              {forages.map((f: any) => (
                <tr key={f.id}>
                  <td>{f.reference}</td>
                  <td>{f.libelle}</td>
                  <td>{f.localite_nom || f.localite}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Secteurs */}
        <div className="data-table-wrapper">
          <h3 style={{ marginBottom: 15 }}>Secteurs ({secteurs.length})</h3>
          <table className="data-table">
            <thead>
              <tr><th>Libelle</th><th>Localite</th></tr>
            </thead>
            <tbody>
              {secteurs.slice(0, 20).map((s: any) => (
                <tr key={s.id}>
                  <td>{s.libelle}</td>
                  <td>{s.localite_nom}</td>
                </tr>
              ))}
              {secteurs.length > 20 && (
                <tr><td colSpan={2} style={{ textAlign: 'center', color: '#999' }}>... et {secteurs.length - 20} autres</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PartenaireDetail;
